const resolveTaxonomyFacets = ({ rawVal }: TaxonomyFacetsProps) =>
  rawVal?.map((taxonomyFacet: string) => `tax_${taxonomyFacet?.replace(/-/g, '_')}`);

export default resolveTaxonomyFacets;
